import { Github, Linkedin, Twitter, Send, Sparkles } from "lucide-react";
import { profile } from "../data/site";
import { staggerDelay } from "../lib/stagger";
import PageMeta from "../components/PageMeta";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  github: Github,
  linkedin: Linkedin,
  twitter: Twitter,
  telegram: Send,
};

export default function Home() {
  return (
    <div className="flex flex-col gap-28 py-20 md:py-32">
      <PageMeta
        title="Sherxon | Software Engineer"
        description="Sherxon builds things & mentors people. Software engineer focused on mobile and web apps."
        canonicalPath="/"
      />
      {/* Hero */}
      <section className="relative flex flex-col gap-8">
        <div className="hero-glow" />

        <div
          className="stagger-in flex items-center gap-2 text-sm font-medium text-primary"
          style={{ animationDelay: staggerDelay(0) }}
        >
          <Sparkles className="h-4 w-4" />
          <span className="tracking-wide">Available for projects</span>
        </div>

        <h1
          className="stagger-in font-display text-5xl font-bold tracking-tight sm:text-6xl lg:text-7xl"
          style={{ animationDelay: staggerDelay(1) }}
        >
          {profile.name}
        </h1>

        <p
          className="stagger-in text-2xl text-muted-foreground sm:text-3xl"
          style={{ animationDelay: staggerDelay(2) }}
        >
          {profile.headline}
        </p>

        <p
          className="stagger-in max-w-lg text-base leading-relaxed text-muted-foreground/70"
          style={{ animationDelay: staggerDelay(3) }}
        >
          {profile.bio}
        </p>

        {/* Socials */}
        <div
          className="stagger-in flex flex-wrap items-center gap-3 pt-2"
          style={{ animationDelay: staggerDelay(4) }}
        >
          {profile.socials.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg border border-border bg-secondary/40 px-4 py-2.5 text-sm font-medium text-foreground backdrop-blur-sm transition-all hover:border-primary/40 hover:bg-secondary/70 hover:shadow-[0_0_16px_-4px] hover:shadow-primary/20"
              >
                {Icon && <Icon className="h-4 w-4" />}
                {s.label}
              </a>
            );
          })}
        </div>
      </section>

      {/* Interests */}
      <section
        className="stagger-in flex flex-col gap-5"
        style={{ animationDelay: staggerDelay(5) }}
      >
        <h2 className="text-xs font-semibold uppercase tracking-[0.25em] text-muted-foreground">
          Tech I love
        </h2>
        <div className="flex flex-wrap gap-2.5">
          {profile.interests.map((tag) => (
            <span
              key={tag}
              className="rounded-full border border-border bg-secondary/30 px-4 py-1.5 text-sm text-foreground/80 transition-colors hover:border-primary/30 hover:text-foreground"
            >
              {tag}
            </span>
          ))}
        </div>
      </section>
    </div>
  );
}
